var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Kode Lokasi","label-for":"kodeLokasi","label-class":"pb-0 pt-0"}},[_c('b-form-input',{attrs:{"disabled":""},model:{value:(_vm.kolok),callback:function ($$v) {_vm.kolok=$$v},expression:"kolok"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }